import {Injectable} from '@angular/core';
import {PKEY} from '../../constants/persistence.constants';
import {PARAM} from '../../constants';
import {PersistenceService} from './persistence.service';


@Injectable()
export class SearchService {
  public clienteID : number = -1;

  constructor(
    private persistence: PersistenceService
  ) {
    this.clienteID = this.persistence.get(PKEY.SEARCH_CLIENTE_ID);
  }



  setClienteID(id: number | undefined){
    this.persistence.set(PKEY.SEARCH_CLIENTE_ID, id);
  }







}

